
import { ABTHelper } from '@tencent/wphk-components-abt';
let abtHelper: ABTHelper;

// abt实验缓存key值
const AbtestCacheKey = 'discount_center_home_newguide_abtestid';

/**
 * 实验ID
 */
export enum abTestId {
  /** 展示新手引导 */
  'ShowGuide' = '137541',
  /** 不展示新手引导 */
  'HideGuide' ='137540',
};

/**
 * 实验初始化
 */
export const abtInit = async () => {
  if (getAbTestID()) return;
  abtHelper = new ABTHelper({ abtModuleSet: '202306_discountcenter_popup' });
  const isInit = await abtHelper.initABTInfo();
  if (!isInit) {
    console.log('====init fail');
  }
  saveAbTestId(abtHelper.getAbtLabelId());
};

/**
 * 保存实验ID
 */
export function saveAbTestId(abtestId: string) {
  sessionStorage.setItem(AbtestCacheKey, ([abTestId.ShowGuide, abTestId.HideGuide] as string[])
    .includes(abtestId) ? abtestId : abTestId.HideGuide);
}

/**
 * 获取实验ID
 */
export function getAbTestID() {
  return sessionStorage.getItem(AbtestCacheKey);
}

/**
 * 是否展示新手引导
 */
export function isShowNewGuide() {
  return getAbTestID() === abTestId.ShowGuide;
}

